export type ActivityTone = {
  accent: string
  chipLabel?: string
  hoverBg: string
}

const TONES = {
  deleted: {
    accent: '#eb627a',
    chipLabel: 'Deleted',
    hoverBg: 'rgba(235, 98, 122, 0.06)',
  },
  edited: {
    accent: '#eeE4A11B',
    chipLabel: 'Edited',
    hoverBg: 'rgba(238, 164, 27, 0.06)',
  },
  default: {
    accent: '#37A239',
    hoverBg: 'rgba(0, 0, 0, 0.03)',
  },
} as const

export function getActivityTone(title: string): ActivityTone {
  const lower = title.toLowerCase()
  if (lower.includes('deleted')) {
    return TONES.deleted
  }
  if (lower.includes('edited')) {
    return TONES.edited
  }
  return TONES.default
}

/** @deprecated Use getActivityTone for web table rows */
export function getActivityTitleColor(title: string): string {
  return getActivityTone(title).accent
}
